import {
  VinoDataImage,
  generateStorefrontImage,
} from "../utils/generate-storefront-image";

import { FeaturedCollections } from "../components/blocks/featured-collections";
import { LinkTo } from "../types";

interface ContentfulCollectionBanner {
  backgroundImage: VinoDataImage;
  headerImage: VinoDataImage;
  navigationName: string;
  navigationColor: string;
  title?: string;
  bodyText?: string;
  primaryCta: {
    buttonColour: string;
    buttonBorderColor: string;
    buttonTextColor: string;
    buttonHoverBorderColor?: string;
    buttonHoverBackgroundColor?: string;
    buttonHoverTextColor?: string;
    label: string;
    linkTo: LinkTo;
  };
}

interface ContentfulFeaturedCollectionsProps {
  __typename: string;
  title?: string;
  collections: Array<ContentfulCollectionBanner>;
}

const test = ({ __typename }: ContentfulFeaturedCollectionsProps): boolean =>
  __typename === "VinoData_FeaturedCollections";

const create = (data: ContentfulFeaturedCollectionsProps): JSX.Element => {
  const transformedData = {
    ...data,
    collections: data.collections.map((collection) => ({
      ...collection,
      backgroundImage: generateStorefrontImage(collection.backgroundImage, {}),
      headerImage: generateStorefrontImage(collection.headerImage, {}),
    })),
  };
  return <FeaturedCollections {...transformedData} />;
};

export default { test, create };
